import { CardPrinterPagePrintedCardsTab } from "@features/card-printer/components/CardPrinterPagePrintedCardsTab";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/assets/card-printer/printed-cards")({
    component: CardPrinterPagePrintedCardsTab,
        staticData: {
        crumb: {
            label: "Printed cards"
        }
    }
});
